import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { createContext, useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { USER_QUERY } from '@app/apollo/queries';
var AuthUserContext = /*#__PURE__*/createContext();
var AuthUserProvider = function AuthUserProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    user = _useState[0],
    setUser = _useState[1];
  var _useState2 = useState(null),
    formattedAuthUser = _useState2[0],
    setFormattedAuthUser = _useState2[1];
  var _useState3 = useState(false),
    isAuthenticated = _useState3[0],
    setIsAuthenticated = _useState3[1];
  var _useLazyQuery = useLazyQuery(USER_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    authUserQuery = _useLazyQuery2[0],
    loadingUser = _useLazyQuery2[1].loading;
  var fetchUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return authUserQuery({
                onCompleted: function onCompleted(data) {
                  if (data) {
                    setUser(data.me);
                    setIsAuthenticated(!!data.me);
                  }
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function fetchUser() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchUser();
  }, []);
  useEffect(function () {
    if (user) {
      setFormattedAuthUser({
        id: user.id,
        name: user.name,
        email: user.email,
        avatar: user.avatar
      });
    }
  }, [user]);
  var reloadAuthUser = function reloadAuthUser() {
    fetchUser();
  };
  return /*#__PURE__*/React.createElement(AuthUserContext.Provider, {
    value: {
      user: user,
      loadingUser: loadingUser,
      isAuthenticated: isAuthenticated,
      formattedAuthUser: formattedAuthUser,
      fetchUser: fetchUser,
      reloadAuthUser: reloadAuthUser,
      setUser: setUser
    }
  }, children);
};
export { AuthUserContext };
export default AuthUserProvider;